import { render, staticRenderFns } from "./topInfo.vue?vue&type=template&id=65df4904&scoped=true&"
import script from "./topInfo.vue?vue&type=script&lang=js&"
export * from "./topInfo.vue?vue&type=script&lang=js&"
import style0 from "./topInfo.vue?vue&type=style&index=0&id=65df4904&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65df4904",
  null
  
)

export default component.exports